import { APIFactory } from '../api/api.factory'
const MiscExpenseReportAPI = APIFactory.get('miscreports')


export default {
    async get(erid) {
        const { data } = await MiscExpenseReportAPI.get(erid)
        return data;
    },
    async save(report) {
        const { data } = await MiscExpenseReportAPI.save(report)
        //report.miscReportItems.forEach(function (mRItem) {
        //    mrItem.projectAmountAllocations.forEach(function (pAAItem) {
        //        mrItem.amount = Number(mrItem.amount) + Number(pAAItem.allocationValue)
        //    })
        //})
        return data;
    },
    async submit(submit) {
        const { data } = await MiscExpenseReportAPI.submit(submit)
        return data;
    },
    async getItemTypes() {
        const { data } = await MiscExpenseReportAPI.getItemTypes()
        return data;
    }
}